import axios from "axios";

const ENDPOINT_KEY = "customer";
const ENDPOINT_URI = "/customer";

export default function useCustomerService() {
  return {
    queryKey: ENDPOINT_KEY,
    getCustomersByCampaignId: async (
      campaignId,
      search = "",
      page = 1,
      limit = 10
    ) => {
      const params = new URLSearchParams({
        page,
        limit,
      });
      if (search) {
        params.append("search", search);
      }
      const response = await axios.get(
        `${ENDPOINT_URI}/campaign/${campaignId}`,
        {
          params,
        }
      );
      return response.data.payload;
    },
    getAllCustomers: async (search = "", type = "", page = 1, limit = 10) => {
      const params = new URLSearchParams({
        page,
        limit,
      });
      if (search) {
        params.append("search", search);
      }
      if (type) {
        params.append("type", type);
      }
      const response = await axios.get(`${ENDPOINT_URI}/`, { params });
      return response.data.payload;
    },
    getCustomerById: async (id) => {
      const response = await axios.get(`${ENDPOINT_URI}/${id}`);
      return response.data.payload;
    },
    createCustomer: async ({ payload }) => {
      const response = await axios.post(`${ENDPOINT_URI}/`, payload);
      return response.data.payload;
    },
    updateCustomer: async ({ id, payload }) => {
      const response = await axios.put(`${ENDPOINT_URI}/${id}`, payload);
      return response.data.payload;
    },
    deleteCustomer: async (id) => {
      const response = await axios.delete(`${ENDPOINT_URI}/${id}`);
      return response.data.payload;
    },
  };
}
